export const DEFAULT_REFERRAL_FILTERS = {
    search: '',
    status: null,
    dateFrom: '',
    dateTo: '',
    createdBy: null,
};
